// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cs-message--outgoing .cs-message__content {
  background-color: #45a735 !important;
  color: white !important;
}
.cs-message--incoming .cs-message__content {
  background-color: white !important;
  color: #262626 !important;
}
.custom-bg-chat {
  background-color: #f4f5f7 !important;
}
.custom-bg-chat-disabled {
  background-color: #f4f5f7 !important;
  text-align: center !important;
  color: black !important;
}
.custom-chat-input {
  border-top: unset !important;
  .cs-message-input__content-editor-wrapper {
    background-color: white;
  }
  .cs-message-input__content-editor {
    background-color: white;
  }
}
.custom-chat-line {
  background-color: #f4f5f7 !important;
  color: #7a7a7a !important;
}
.cs-message-separator::before {
  background-color: #ebebeb !important;
}
.cs-message-separator::after {
  background-color: #ebebeb !important;
}
.cs-message-list__scroll-wrapper {
  touch-action: auto !important;
  overscroll-behavior-y: auto !important;
}
.cs-conversation {
  border-bottom: solid 1px !important;
  border-bottom-color: #D3D3D3 !important;
}
.cs-conversation--active {
  background-color: #eeffec !important;
}

.cs-conversation__name {
  color: #262626 !important;
  font-weight: 600 !important;
}

.cs-conversation__info-content {
  color: #262626 !important;
  font-weight: 400 !important;
}

.cs-conversation__last-activity-time {
  color: #7A7A7A !important;
  font-weight: 400 !important;
  min-width: 65px;
}
.disable-chat-line {
  color: black !important;
  margin-bottom: 4px;
  font-size: 15px;
}
.disable-chat-line.cs-message-separator::before {
  background-color: white !important;
}
.disable-chat-line.cs-message-separator::after {
  background-color: white !important;
}
.cs-conversation__unread-dot {
  background: red !important;
  box-shadow: none !important;
  position: absolute;
  right: 15px;
  top: 45px 
}

.cs-message__content-wrapper {
  min-width: 40% !important;
}

.cs-overlay__content .cs-loader {
  margin-top: 120px !important;
}

@media (max-width: 559px) {
  .cs-message__content-wrapper {
    width: 100%;
  }
}`, "",{"version":3,"sources":["webpack://./src/features/comms/screens/comms-chat.css"],"names":[],"mappings":"AAAA;EACE,oCAAoC;EACpC,uBAAuB;AACzB;AACA;EACE,kCAAkC;EAClC,yBAAyB;AAC3B;AACA;EACE,oCAAoC;AACtC;AACA;EACE,oCAAoC;EACpC,6BAA6B;EAC7B,uBAAuB;AACzB;AACA;EACE,4BAA4B;EAC5B;IACE,uBAAuB;EACzB;EACA;IACE,uBAAuB;EACzB;AACF;AACA;EACE,oCAAoC;EACpC,yBAAyB;AAC3B;AACA;EACE,oCAAoC;AACtC;AACA;EACE,oCAAoC;AACtC;AACA;EACE,6BAA6B;EAC7B,sCAAsC;AACxC;AACA;EACE,mCAAmC;EACnC,uCAAuC;AACzC;AACA;EACE,oCAAoC;AACtC;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;EAC3B,eAAe;AACjB;AACA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,kCAAkC;AACpC;AACA;EACE,kCAAkC;AACpC;AACA;EACE,0BAA0B;EAC1B,2BAA2B;EAC3B,kBAAkB;EAClB,WAAW;EACX;AACF;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE;IACE,WAAW;EACb;AACF","sourcesContent":[".cs-message--outgoing .cs-message__content {\n  background-color: #45a735 !important;\n  color: white !important;\n}\n.cs-message--incoming .cs-message__content {\n  background-color: white !important;\n  color: #262626 !important;\n}\n.custom-bg-chat {\n  background-color: #f4f5f7 !important;\n}\n.custom-bg-chat-disabled {\n  background-color: #f4f5f7 !important;\n  text-align: center !important;\n  color: black !important;\n}\n.custom-chat-input {\n  border-top: unset !important;\n  .cs-message-input__content-editor-wrapper {\n    background-color: white;\n  }\n  .cs-message-input__content-editor {\n    background-color: white;\n  }\n}\n.custom-chat-line {\n  background-color: #f4f5f7 !important;\n  color: #7a7a7a !important;\n}\n.cs-message-separator::before {\n  background-color: #ebebeb !important;\n}\n.cs-message-separator::after {\n  background-color: #ebebeb !important;\n}\n.cs-message-list__scroll-wrapper {\n  touch-action: auto !important;\n  overscroll-behavior-y: auto !important;\n}\n.cs-conversation {\n  border-bottom: solid 1px !important;\n  border-bottom-color: #D3D3D3 !important;\n}\n.cs-conversation--active {\n  background-color: #eeffec !important;\n}\n\n.cs-conversation__name {\n  color: #262626 !important;\n  font-weight: 600 !important;\n}\n\n.cs-conversation__info-content {\n  color: #262626 !important;\n  font-weight: 400 !important;\n}\n\n.cs-conversation__last-activity-time {\n  color: #7A7A7A !important;\n  font-weight: 400 !important;\n  min-width: 65px;\n}\n.disable-chat-line {\n  color: black !important;\n  margin-bottom: 4px;\n  font-size: 15px;\n}\n.disable-chat-line.cs-message-separator::before {\n  background-color: white !important;\n}\n.disable-chat-line.cs-message-separator::after {\n  background-color: white !important;\n}\n.cs-conversation__unread-dot {\n  background: red !important;\n  box-shadow: none !important;\n  position: absolute;\n  right: 15px;\n  top: 45px \n}\n\n.cs-message__content-wrapper {\n  min-width: 40% !important;\n}\n\n.cs-overlay__content .cs-loader {\n  margin-top: 120px !important;\n}\n\n@media (max-width: 559px) {\n  .cs-message__content-wrapper {\n    width: 100%;\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
